export type TokenGetter = () => Promise<string | null>

async function fetchWithAuth(getToken: TokenGetter, path: string, options: RequestInit = {}) {
  const token = await getToken()
  if (!token) {
    throw new Error('Authentication required. Please sign in.')
  }

  const headers = new Headers(options.headers)
  headers.set('Content-Type', 'application/json')
  headers.set('Authorization', `Bearer ${token}`)

  const res = await fetch(path, { ...options, headers })
  if (!res.ok) {
    const body = await res.json().catch(() => ({}))
    const message = body.error || body.message || `Request failed: ${res.status}`
    throw new Error(message)
  }
  return res.json()
}

export function createApi(getToken: TokenGetter) {
  return {
    getMe: () => fetchWithAuth(getToken, '/api/me'),
    updateMe: (data: unknown) => fetchWithAuth(getToken, '/api/me', { method: 'PATCH', body: JSON.stringify(data) }),
    getInvoices: () => fetchWithAuth(getToken, '/api/invoices'),
    createInvoice: (data: unknown) => fetchWithAuth(getToken, '/api/invoices', { method: 'POST', body: JSON.stringify(data) }),
    getInvoice: (id: string) => fetchWithAuth(getToken, `/api/invoices/${id}`),
    updateInvoice: (id: string, data: unknown) => fetchWithAuth(getToken, `/api/invoices/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
    markPaid: (id: string) => fetchWithAuth(getToken, `/api/invoices/${id}/mark-paid`, { method: 'POST' }),
    pauseInvoice: (id: string) => fetchWithAuth(getToken, `/api/invoices/${id}/pause`, { method: 'POST' }),
    resumeInvoice: (id: string) => fetchWithAuth(getToken, `/api/invoices/${id}/resume`, { method: 'POST' }),
    sendTestEmail: (invoiceId?: string) => fetchWithAuth(getToken, '/api/reminders/send-test', { method: 'POST', body: JSON.stringify(invoiceId ? { invoice_id: invoiceId } : {}) }),
  }
}

export type Api = ReturnType<typeof createApi>
